import React, { useState, useCallback } from 'react'
import withPage from 'server/withPage'
import queryString from 'query-string'
import SignUpReconfirmationPage from 'components/pages/SignUpReconfirmationPage'
import { bindActionCreators } from 'redux'
import { setUIState } from 'redux/modules/ui'
import { Redirect } from 'react-router-dom'
import Path from 'routes/path'

/**
 * @type {React.FC<{
 *  ui: any,
 *  actions: {
 *   setUIState: Function,
 *  },
 *  config: any,
 *  restClient: {
 *    get: (path: string, params: Record<string, unknown>) => Promise<any>,
 *    post: (path: string, params: Record<string, unknown>) => Promise<any>,
 *  },
 * }>}
 */

const Container = props => {
  const {
    location: { search },
  } = props
  const { restClient } = props
  const [isLoading, setIsLoading] = useState(false)
  const [isSend, setIsSend] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [, setRetryCount] = useState(0)
  const queries = queryString.parse(search)
  const token = queries.token
  const done = queries.done ? encodeURIComponent(queries.done) : ''
  const isEmailConfirmation = !token

  const sendConfirmation = useCallback(async email => {
    setIsLoading(true)
    try {
      // 共通のヘッダーを変更してしまっているが、ここ以外でrest使わないので問題ない
      restClient.headers.accept = 'application/json'
      // https://github.com/spacemarket/spmkt_api/blob/95090e1455470bcb92624709341139c99b35d2d2/app/controllers/users/confirmations_controller.rb#L56-L89
      // 成功 → 201,
      // メールでの確認でメールが存在しない場合は → 404
      // それ以外 → 403
      await restClient.post('i/confirmation', {
        ...(token && { confirmation_token: token }),
        ...(done && { done }),
        ...(email && { email }),
      })

      setIsSend(true)
    } catch (e) {
      // 登録済みメールアドレスを調べるために悪用される可能性があるので、リトライ回数をカウントして5回以上の場合はSentryに送る
      setRetryCount(prev => {
        const retryCount = prev + 1

        if (retryCount >= 5) {
          Sentry.captureException(
            new Error('メールアドレス確認のリトライ回数が5回を超えました。'),
            {
              extra: {
                retryCount: retryCount,
              },
            },
          )
        }

        return retryCount
      })

      const { status } = e.response

      if (status === 404) {
        setErrorMessage('メールアドレスが存在しません。')
      } else if (status === 403) {
        setErrorMessage('有効期限が切れています。')
      } else {
        // 意図しないエラーの場合はSentryに送る
        Sentry.captureException(e)
        setErrorMessage('エラーが発生しました。')
      }
    }
    setIsLoading(false)
  }, [])

  return isSend ? (
    <Redirect to={Path.signUpSent()} />
  ) : (
    <SignUpReconfirmationPage
      isEmailConfirmation={isEmailConfirmation}
      isLoading={isLoading}
      errorMessage={errorMessage}
      sendConfirmation={sendConfirmation}
      {...props}
    />
  )
}

function mapStateToProps(state) {
  return state
}
function mapDispatchToProps(dispatch) {
  const bindActions = { setUIState }
  return { actions: bindActionCreators(bindActions, dispatch) }
}
export default withPage(Container, mapStateToProps, mapDispatchToProps, {})
